import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Language } from '../../models/language.model';
import { FormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  selector: 'app-languages-switcher',
  imports: [FormsModule, TranslateModule],
  templateUrl: './languages-switcher.component.html',
  styleUrl: './languages-switcher.component.scss'
})
export class LanguagesSwitcherComponent {
  languages: Language[] = [
    {
      "id": 1,
      "name": "french",
      "short": "fr",
    },
    {
      "id": 2,
      "name": "english",
      "short": "en",
    }
  ];

  currentLanguage: string = 'en';

  constructor(private translate: TranslateService) {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      this.currentLanguage = savedLanguage;
    }
  }

  switchLanguage(event: Event): void {
    const languageCode = (event.target as HTMLSelectElement).value;
    this.currentLanguage = languageCode;
    this.translate.use(languageCode);
    localStorage.setItem('language', languageCode);
  }
}